import client from '../httpClient';

// 【sms003】SMS送信
const smsPostApi = (obj) => {
  const POST_SMS_URL = '/sms';
  return client.post(POST_SMS_URL, JSON.stringify(obj));
};

export default smsPostApi;
